var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('CompareMortgageProviderForm',{attrs:{"langcode":_vm.langcode,"is-advisor":_vm.isAdvisor}}),_c('CompareMortgageProviderDisplay',{attrs:{"langcode":_vm.langcode,"api-key":_vm.apiKey,"office-id":_vm.officeId,"is-advisor":_vm.isAdvisor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }